import React from 'react';
import ModifiedBadge from './ModifiedBadge';
import TruncatedCopyCell from './TruncatedCopyCell';

function SpanishCellPopover({ request, displayText, maxDisplayLength = 60 }) {
  const fullText = request?.target || request?.Spanish || '';
  const truncated = displayText
    || (fullText.length > maxDisplayLength
      ? fullText.substring(0, maxDisplayLength) + '...'
      : fullText);

  return (
    <span className="cell-with-badge">
      <TruncatedCopyCell
        value={fullText}
        displayText={truncated || '-'}
        copyAriaLabel="Copy Translation"
        tooltipWrap
        textClassName="spanish-cell-text"
      />
      <ModifiedBadge request={request} />
    </span>
  );
}

export default SpanishCellPopover;
